import { useState } from "react";
import { X, Package, MapPin, Check } from "lucide-react";
import api, { formatErr } from "../lib/api";

export default function TrackShipmentModal({ open, onClose }) {
  const [code, setCode] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const track = async (e) => {
    e.preventDefault();
    setLoading(true); setErr(""); setData(null);
    try { const r = await api.get(`/track/${encodeURIComponent(code.trim())}`); setData(r.data); }
    catch (e) { setErr(formatErr(e)); } finally { setLoading(false); }
  };
  if (!open) return null;
  return (
    <div data-testid="track-modal" className="fixed inset-0 z-50 flex items-center justify-center p-6 maintenance-blur" onClick={onClose}>
      <div className="bg-white border border-black/10 max-w-xl w-full p-10 relative shadow-2xl" onClick={(e)=>e.stopPropagation()}>
        <button data-testid="track-modal-close" onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-dark"><X size={18}/></button>
        <div className="overline mb-3">Tracking</div>
        <h2 className="font-display text-3xl text-dark mb-2">Track Your Shipment</h2>
        <p className="text-sm text-gray-500 mb-6">Enter your order number or DHL tracking ID</p>
        <form onSubmit={track} className="flex gap-3">
          <input data-testid="track-input" required placeholder="LX-123456 or DHL number" className="input-box flex-1" value={code} onChange={(e)=>setCode(e.target.value)}/>
          <button data-testid="track-submit" type="submit" disabled={loading} className="btn-primary">{loading? "…" : "Track"}</button>
        </form>
        {err && <div className="mt-5 text-sm text-red-600">{err}</div>}
        {data && (
          <div data-testid="track-result" className="mt-8">
            <div className="flex items-center justify-between mb-4">
              <div><div className="overline">Order</div><div className="font-display text-xl text-dark">{data.order_number}</div></div>
              <div className="text-right"><div className="overline">Status</div><div className="text-copper text-sm uppercase tracking-luxe">{data.status}</div></div>
            </div>
            <div className="text-xs text-gray-500 flex items-center gap-2 mb-6"><MapPin size={13}/> {data.shipping_city}, {data.shipping_country} {data.tracking_number && <span className="text-gray-400">· DHL: {data.tracking_number}</span>}</div>
            <div className="space-y-3">
              {data.timeline.map((t, i) => (
                <div key={i} className="flex items-center gap-4">
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center ${t.done? "bg-copper text-white" : "bg-[#F5F2ED] text-gray-400 border border-black/5"}`}>
                    {t.done ? <Check size={13}/> : <Package size={13}/>}
                  </div>
                  <div className={`flex-1 text-sm ${t.done? "text-dark" : "text-gray-400"}`}>{t.status}</div>
                </div>
              ))}
            </div>
            {data.dhl_live && <div className="mt-5 text-xs text-gray-500 italic">{data.dhl_live.note}</div>}
          </div>
        )}
      </div>
    </div>
  );
}
